import { useCookies } from "react-cookie";

export function UserNotFound({}) {
  const [cookies, setCookie, removeCookie] = useCookies("");

  const handleLogin = () => {

    const cookieOptions = {
      domain: process.env.REACT_APP_COMMON_DOMAIN,
      path: "/",
    };
    removeCookie("refreshTokenDMS", cookieOptions);
    localStorage.clear();
    const redirectUri = process.env.REACT_APP_REDIRECTURI;
    const clientId = process.env.REACT_APP_CLIENTID;
    const scope = process.env.REACT_APP_SCOPE;
    const accesstype = process.env.REACT_APP_ACCESS_TYPE;
    const prompt = process.env.REACT_APP_PROMPT;
    const authUrl =
      process.env.REACT_APP_AUTHURL +
      `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=${accesstype}&prompt=${"consent"}`;
    window.location.href = authUrl;
  };
  // const handleLogin = () => {
  //     // localStorage.setItem("isUserValid", false)
  //     localStorage.clear();
  //     window.location.pathname = "/";
  //     window.location.href = process.env.REACT_APP_LOGOUT;
  // }

  return (
    <>
      <div className="text-center w-100">
        <p className="mb-12 usernotfound">
          You're not authorized to access this application. Please contact
          administrator.
        </p>
        <p
          className="cursor-pointer a-tag text-decoration"
          onClick={handleLogin}
        >
          Go to Login
        </p>
      </div>
    </>
  );
}
